<template>
  <div>
    <div class="md-layout md-gutter">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-34.5"
        v-for="type of ['total', 'periodic', 'routine']"
        :key="type"
      >
        <stats-card :header-color="plan[type].color">
          <template slot="header">
            <div class="card-icon">
              <i :class="plan[type].icon"></i>
              <!--span style="font-size:32px; font-weight:500;">
                {{ type.charAt(0).toUpperCase() }}
              </span-->
            </div>
            <p class="category">
              {{ `${$t(`planning.card_changed_${type}_cost`)}` }}
            </p>
            <h3 class="title">
              <animated-number
                :value="plan[type].budget_start"
              ></animated-number>
            </h3>
          </template>
          <template slot="footer">
            <div class="stats">
              <md-icon>published_with_changes</md-icon>
              <span
                :style="{
                  color:
                    plan[type].budget_changed > plan[type].budget_start
                      ? 'red'
                      : plan[type].budget_changed < plan[type].budget_start
                      ? 'blue'
                      : 'green'
                }"
              >
                {{ `${$t(`planning.card_changed_cost`)}:` }}
                <animated-number
                  :value="plan[type].budget_changed"
                ></animated-number>
              </span>
            </div>
          </template>
        </stats-card>
      </div>
    </div>
    <md-steppers :md-active-step.sync="stepActive" md-linear>
      <md-step
        v-for="step of steps"
        :key="step.label"
        :id="step.label"
        :md-label="$t(`planning.step_${step.label}`)"
        md-description=""
        :md-done.sync="step.done"
        :md-editable="step.editable"
        @click="onActiveStepChange(step.label)"
      >
        <template v-if="step.label === stepActive">
          <PlanningRoadTable
            :isPlanDataLoading="isPlanDataLoading"
            :isPlanDataGenerating="isPlanDataGenerating"
            :isPlanExportDataLoading="isPlanExportDataLoading"
            :plan_data="planData"
            :plan_id="plan_id"
            :hasParent="isSetRoadcode"
            :pagPerPage="pagPerPage"
            :pagCurrentPage="pagCurrentPage"
            :searchQueryDef="searchQueryDef"
            :filterQueryDef="filterQueryDef"
            :lsort="lsort"
            :isCommitEnable="isStepCommitEnable"
            @onChangePlanParams="onChangePlanParams"
            @onExport="onTableDataExport"
            @onGoToPrev="onGoToPrev"
            @onGoToPage="onTableGoToPage"
            @onSearch="onTableSearch"
            @onChangePerPage="onTableChangePerPage"
            @onChangeLevelNext="onChangeTableLevelNext"
            @onChangeLevelPrev="onChangeTableLevelPrev"
            @changedCurrentPlanCost="changedCurrentPlanCost"
            @onChangeSort="onChangeTableSort"
            @onCommitCurrentPlanTypeChanges="onCommitCurrentPlanTypeChanges"
            @onGenPlanData="onGenCurrentPlanData"
            @onModifyTableData="onModifyTableData"
            @onSavePlanData="onSaveTablePlanData"
            @setFilter="setTableFilter"
          ></PlanningRoadTable>
        </template>
      </md-step>
    </md-steppers>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import {StatsCard, AnimatedNumber, NavTabsCard} from '@/components'
import Swal from 'sweetalert2'
import {
  PlanningRoadTable,
  PlanningSegmentTable
} from '@/components/viewPlanning'
import {mapState} from 'vuex'

export default {
  name: 'plannimg-page',
  components: {
    StatsCard,
    AnimatedNumber,
    PlanningRoadTable

    //PlanningSegmentTable
  },
  props: {
    plan_id: {type: String, requred: true}
  },
  data() {
    return {
      isPlanDataLoading: true,
      isPlanExportDataLoading: false,
      isPlanDataGenerating: false,
      planData: {headers: [], rows: []},
      selectedPlan: '',
      steps: [
        {label: 'periodic', done: false, editable: true, isCommitEnable: true},
        {label: 'routine', done: false, editable: true, isCommitEnable: true},
        {label: 'final', done: false, editable: true, isCommitEnable: false}
      ],
      stepActive: '',
      plan_state: '',
      plan_list: [],
      plan: {
        total: {
          color: 'blue',
          icon: 'far fa-object-group',
          budget_start: 0,
          budget_changed: 0
        },
        periodic: {
          color: 'warning',
          icon: 'fas fa-dice-one',
          budget_start: 0,
          budget_changed: 0
        },
        routine: {
          color: 'green',
          icon: 'fas fa-dice-two',
          budget_start: 0,
          budget_changed: 0
        }
      },

      lsortDef: 'start_m',
      lsort: '',
      queryTableLevelPrev: {page: 1},
      pagPerPage: 10,
      pagPerPageDef: 50,
      pagCurrentPage: 1,
      planModifyedData: {},
      searchQueryDef: '',
      filterQueryDef: {}
    }
  },
  watch: {
    roadcode() {
      this.onUpdateTableData()
    },
    plan_id() {
      this.onUpdateTableData()
    },
    total_budget_changed(newVal) {
      this.plan.total.budget_changed = newVal
    }
  },
  beforeRouteUpdate(to, from, next) {
    next()
  },
  async created() {
    const {
      type = 'periodic',
      filter = '',
      limit = this.pagPerPageDef,
      lsort = this.lsortDef,
      filter_by = [],
      filter_values = []
    } = this.$route.query

    this.stepActive = type
    this.searchQueryDef = filter
    this.pagPerPage = +limit

    try {
      if (this.plan_id === 'def') {
        console.time('LOAD_PLAN_LIST')
        this.plan_list = await this.$store.dispatch('LOAD_PLAN_LIST')
        const maxPlanInd = this.plan_list.reduce(
          (maxValInd, curr, ind, arr) => {
            return curr.id > arr[maxValInd].id ? ind : maxValInd
          },
          0
        )
        this.$router.push({
          name: 'Planning-data',
          params: {
            plan_id: this.plan_list[maxPlanInd].id.toString()
          }
        })

        console.timeEnd('LOAD_PLAN_LIST')
      } else {
        await this.onUpdateTableData()
      }
    } catch (err) {
      console.error(err)
    }
  },
  methods: {
    onChangeTableSort(val) {
      this.routerQueryUpdate({lsort: val})
    },

    async onTableDataExport() {
      this.isPlanExportDataLoading = true
      try {
        const defQuery = this.getQueryForLoadPlanData()
        const {length} = this.planData
        const reqQuery = {...defQuery, detailed: true, limit: 1000000}
        console.time('LOAD_EXPORT_DATA')
        const plan_data = await this.$store.dispatch('LOAD_PLAN_DATA', {
          plan_id: this.plan_id,
          reqQuery
        })
        console.timeEnd('LOAD_EXPORT_DATA')
        const {
          headers: table_headers,
          rows: table_rows,
          to_localise
        } = plan_data
        const headers = table_headers.map((header) =>
          this.$t(`planning.table_${header}`)
        )
        const rows = table_rows.map((row) => {
          const currRow = [...row]
          return currRow.map((field, ind) => {
            return !Array.isArray(field)
              ? to_localise.includes(ind)
                ? this.$t(field)
                : field
              : field
                  .map((el) => {
                    return to_localise.includes(ind) ? this.$t(el) : el
                  })
                  .join(', ')
          })
        })
        console.time('CREATE_XLSX_FILE')
        const export_data = [headers, ...rows]
        const today = new Date().toJSON().slice(0, 10)
        const worksheet = XLSX.utils.aoa_to_sheet(export_data)
        const new_workbook = XLSX.utils.book_new()
        const filter_name = !defQuery.filter
          ? ''
          : `_filter(${defQuery.filter})`

        XLSX.utils.book_append_sheet(
          new_workbook,
          worksheet,
          `Plan_${this.plan_id}_${filter_name}`
        )
        XLSX.writeFile(new_workbook, `planning_${defQuery.type}_${today}.xlsx`)
        console.timeEnd('CREATE_XLSX_FILE')
      } catch (err) {
        console.error(err)
      } finally {
        this.isPlanExportDataLoading = false
      }
    },
    onActiveStepChange(val) {
      this.stepActive = val
      this.routerQueryUpdate({
        type: val,
        roadcode: 'none',
        limit: this.pagPerPageDef,
        page: 1,
        filter_by: 'none',
        filter_values: 'none'
      })
      this.onUpdateTableData()
    },
    async onSaveTablePlanData() {
      const planModifyedData = this.planModifyedData
      const changes = {selected: [], deselected: [], type: 'periodic'}
      const alert = {
        title: 'alert.success',
        text: 'alert.the_data_was_saved'
      }
      Object.keys(planModifyedData).forEach((row) => {
        if (planModifyedData[row] === 'added') {
          changes.selected.push(row)
        } else {
          changes.deselected.push(row)
        }
      })

      try {
        await this.$store.dispatch('SAVE_PLAN_DATA', {
          plan_id: this.plan_id,
          changes
        })
        await this.$store.dispatch('SET_PLAN_PARAMS', {
          plan_id: this.plan_id,
          params: {state: changes.type}
        })
        this.loadPlanParams()
      } catch (err) {
        alert.title = 'alert.failure'
        alert.text = 'alert.the_data_was_not_saved'
      } finally {
        Swal.fire({
          title: this.$t(alert.title),
          text: this.$t(alert.text),
          buttonsStyling: false,
          confirmButtonClass: 'md-button md-success',
          type: 'success'
        })
        this.planModifyedData = []
      }
    },
    onModifyTableData(changed) {
      const planModifyedData = this.planModifyedData
      changed.forEach((item, index) => {
        if (planModifyedData[item.id]) {
          if (planModifyedData[item.id] != item.act) {
            delete planModifyedData[item.id]
          }
        } else {
          planModifyedData[item.id] = item.act
        }
      })
    },
    onTableSearch(val) {
      this.routerQueryUpdate({filter: val})
      this.onUpdateTableData()
    },
    setTableFilter(filter) {
      const filter_by = []
      const filter_values = []
      Object.keys(filter).forEach((key) => {
        if (filter[key] !== '') {
          filter_by.push(key)
          filter_values.push(filter[key])
        }
      })

      this.routerQueryUpdate({
        filter_by: filter_by.length > 0 ? filter_by : 'none',
        filter_values: filter_values.length > 0 ? filter_values : 'none'
      })
      this.onUpdateTableData()
    },
    onChangeTableLevelNext(val) {
      this.queryTableLevelPrev = {...this.$route.query}
      this.pagCurrentPage = 1
      this.routerQueryUpdate({
        ...val,
        page: 1,
        limit: this.pagPerPageDef,
        lsort: 'none'
      })

      this.onUpdateTableData()
    },
    onChangeTableLevelPrev(val) {
      this.routerQueryUpdate({
        limit: this.pagPerPageDef,
        ...this.queryTableLevelPrev,
        ...val
      })
      this.onUpdateTableData()
    },
    onTableChangePerPage(val) {
      this.pagCurrentPage = 1
      this.routerQueryUpdate({limit: val, page: 1})
      this.onUpdateTableData()
    },
    onTableGoToPage(val) {
      this.pagCurrentPage = val
      this.routerQueryUpdate({page: val})
      this.onUpdateTableData()
    },

    async generatePlanData(type) {
      try {
        this.isPlanDataGenerating = true
        if (type !== 'final') {
          await this.$store.dispatch('GENERATE_PLAN_DATA', {
            plan_id: this.plan_id,
            type: type
          })
        }
        this.$store.dispatch('SET_PLAN_PARAMS', {
          plan_id: this.plan_id,
          params: {state: type}
        })
      } catch (err) {
      } finally {
        this.isPlanDataGenerating = false
      }
    },
    async onGenCurrentPlanData() {
      await this.generatePlanData(this.stepActive)
      await this.onUpdateTableData()
    },

    async onCommitCurrentPlanTypeChanges() {
      const currStepIndex = this.steps.findIndex(
        (step) => step.label === this.stepActive
      )

      if (~currStepIndex && currStepIndex < this.steps.length) {
        this.steps[currStepIndex].done = true
        const nextStepLabel = this.steps[currStepIndex + 1].label
        const queryParams = {
          page: 1,
          limit: this.pagPerPage,
          type: nextStepLabel,
          roadcode: 'none'
        }
        this.routerQueryUpdate(queryParams)

        if (this.steps.length > currStepIndex + 1) {
          try {
            await this.generatePlanData(nextStepLabel)
            this.onActiveStepChange(nextStepLabel)
          } catch (err) {
            console.error(err)
          } finally {
          }
        }
      }
    },
    changedCurrentPlanCost(val) {
      this.plan[this.stepActive].budget_changed += val
    },
    onGoToPrev() {
      this.$router.go(-1)
    },

    routerQueryUpdate(params) {
      const modQuery = {...this.$route.query}
      Object.keys(params).forEach((item) => {
        if (params[item] === 'none') {
          delete modQuery[item]
        } else {
          modQuery[item] = params[item]
        }
      })
      this.$router.replace({name: 'Planning-data', query: modQuery})
    },

    async loadPlanParams() {
      this.$store.dispatch('LOAD_PLAN_PARAMS', this.plan_id).then((props) => {
        this.plan.total.budget_start = props.total_budget || 0

        this.plan.periodic.budget_start = props.periodic_budget || 0
        this.plan.periodic.budget_changed = props.periodic_sum || 0
        this.plan.routine.budget_start = props.routine_budget || 0
        this.plan.routine.budget_changed = props.routine_sum || 0
        this.plan.total.budget_changed =
          this.plan.periodic.budget_changed + this.plan.routine.budget_changed
        this.plan_state = props.state

        const stateInd = this.steps.findIndex(
          (step) => step.label === this.plan_state
        )

        this.steps.map((step, index) => {
          step.done = index < stateInd ? true : false
        })
      })
    },
    getQueryForLoadPlanData() {
      const {
        type = 'periodic',
        page = this.pagCurrentPage,
        limit = this.pagPerPage,
        filter,
        roadcode,
        filter_by,
        filter_values
      } = this.$route.query

      const reqQuery = Object.assign(
        {},
        {type},
        {page},
        {limit},
        filter && {filter},
        roadcode && {roadcode},
        filter_by && {filter_by},
        filter_values && {filter_values}
      )
      return reqQuery
    },
    async onUpdateTableData() {
      const {lsort = this.lsortDef} = this.$route.query
      const plan_id = this.plan_id

      try {
        this.isPlanDataLoading = true
        const reqQuery = this.getQueryForLoadPlanData()
        const {filter, page, limit, type, filter_by, filter_values} = reqQuery
        this.loadPlanParams()
        this.searchQueryDef = filter ? filter : ''

        this.$store.dispatch('LOAD_PLAN_FILTER_LIST', {
          plan_id,
          type: type
        })
        this.planData = await this.$store.dispatch('LOAD_PLAN_DATA', {
          plan_id,
          reqQuery
        })

        this.pagCurrentPage = +page
        this.pagPerPage = +limit
        this.filterQueryDef = {}
        if (filter_by) {
          if (!Array.isArray(filter_by)) {
            this.filterQueryDef[filter_by] = filter_values
          } else {
            filter_by.forEach((field, index) => {
              this.filterQueryDef[field] = filter_values[index]
            })
          }
        }

        this.lsort = lsort
      } catch (err) {
        console.error(err)
      } finally {
        this.isPlanDataLoading = false
      }
    },

    onChangePlanParams() {
      this.$router.push({
        name: 'Plan-params',
        params: {plan_id: this.plan_id}
      })
    }
  },
  computed: {
    ...mapState({
      //plan_list: (state) => state.Planning.plan_list
    }),
    isSetRoadcode() {
      return this.$route.query.hasOwnProperty('roadcode')
    },
    isStepCommitEnable() {
      const step = this.steps.find((step) => step.label === this.stepActive)
      return step.isCommitEnable
    },
    total_budget_changed() {
      return (
        this.plan.periodic.budget_changed + this.plan.routine.budget_changed
      )
    }
  }
}
</script>

<style lang="scss">
.md-steppers {
  border-radius: 6px;
  .md-stepper {
    padding: 0;
  }

  > .md-steppers-navigation .md-button {
    background-color: #fff !important;
  }
}
</style>
